export const OSDJsonSchema = {
  type: 'object',
  properties: {
    routeID: {
      type: 'string',
    },
    routeTypeID: {
      type: 'string',
    },
    routeSalesRepWorkForceID: {
      type: 'string',
    },
    pointsReturned: {
      type: 'string',
    },
    rejectReason: {
      type: 'string',
    },
    templateCancellationReason: {
      type: 'string',
    },
  },
}

export const OSDUiSchema = {
  type: 'VerticalLayout',
  className: 'OSD-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/routeID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Route ID',
        },
        {
          type: 'Control',
          scope: '#/properties/routeTypeID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Route Type ID',
        },
        {
          type: 'Control',
          scope: '#/properties/routeSalesRepWorkForceID',
          component: 'ReadOnlyFieldWithJson',
          label: 'Route Sales Rep WorkForce ID',
        },
      ],
    },
    {
      type: 'Control',
      scope: '#/properties/pointsReturned',
      component: 'ReadOnlyFieldWithJson',
      label: 'Points Returned',
    },
    {
      type: 'Control',
      scope: '#/properties/rejectReason',
      component: 'ReadOnlyFieldWithJson',
      label: 'Reject Reason',
    },
    {
      type: 'Control',
      scope: '#/properties/templateCancellationReason',
      component: 'ReadOnlyFieldWithJson',
      label: 'Template Cancellation Reason',
    },
  ],
}
